/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { T } from "../../lib/globals";
import { createClientId, today, fmtMoney } from "../../lib/formatters";
import { Btn, Modal, Field, Badge, Input, Select, Textarea } from "./primitives";

function DenyModal({denyReasons, onClose, onConfirm}) {
  const [reason, setReason] = useState(denyReasons[0]||"Outro motivo");
  const [custom, setCustom] = useState("");
  return(
    <Modal open={true} onClose={onClose} title="❌ Negar Pedido">
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <Field label="Justificativa *">
          <Select value={reason} onChange={e=>setReason(e.target.value)}>
            {denyReasons.map(r=><option key={r}>{r}</option>)}
          </Select>
        </Field>
        {reason==="Outro motivo"&&<Field label="Descreva o motivo">
          <Textarea rows={2} value={custom} onChange={e=>setCustom(e.target.value)} placeholder="Descreva o motivo da negação..."/>
        </Field>}
        <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
          <Btn variant="ghost" onClick={onClose}>Cancelar</Btn>
          <Btn variant="danger" onClick={()=>onConfirm(reason==="Outro motivo"?custom||reason:reason)}>❌ Confirmar Negação</Btn>
        </div>
      </div>
    </Modal>
  );
}


function CotacaoModal({order, suppliers, onSave, onClose, setLightbox, show}) {
  const [cSupplier, setCSupplier] = useState(suppliers[0]?.name||"");
  const [cPrices,   setCPrices]   = useState(Object.fromEntries((order.items||[]).map(i=>[i.id,""])));
  const [cObs,      setCObs]      = useState("");
  const [cFiles,    setCFiles]    = useState([]);

  function addCotacaoPdf(){
    const inp=document.createElement("input"); inp.type="file"; inp.accept="application/pdf"; inp.multiple=true;
    inp.onchange=async e=>{
      for(const f of Array.from(e.target.files || [])){
        const dataUrl = await new Promise(r=>{ const fr=new FileReader(); fr.onload=()=>r(fr.result); fr.readAsDataURL(f); });
        setCFiles(p=>[...p,{ id:createClientId("pdf"), name:f.name||"orcamento.pdf", mime:f.type||"application/pdf", url:dataUrl }]);
      }
    };
    inp.click();
  }

  return(
    <Modal open={true} onClose={onClose} title="💰 Registrar Cotação" wide>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <div style={{background:`${T.yellow}15`,border:`1px solid ${T.yellow}44`,borderRadius:10,padding:"10px 16px",fontSize:12,color:T.yellow}}>
          📋 Adicione o preço encontrado por fornecedor. Todas as cotações ficam registradas para auditoria. Para anexar orçamento, este módulo aceita somente PDF.
        </div>
        <Field label="Fornecedor *">
          <Select value={cSupplier} onChange={e=>setCSupplier(e.target.value)}>
            <option value="">Selecione o fornecedor...</option>
            {suppliers.map(s=><option key={s.id} value={s.name}>{s.name}</option>)}
          </Select>
        </Field>
        <div style={{fontWeight:700,fontSize:13,color:T.text,marginBottom:4}}>Preços por item:</div>
        {(order.items||[]).map(item=>(
          <div key={item.id} style={{display:"grid",gridTemplateColumns:"1fr auto",gap:10,alignItems:"center",
            background:T.card2,padding:"10px 14px",borderRadius:8,border:`1px solid ${T.border}`}}>
            <div style={{fontSize:13,color:T.text,fontWeight:500}}>{item.description}</div>
            <div style={{display:"flex",alignItems:"center",gap:6}}>
              <span style={{color:T.muted,fontSize:11}}>R$</span>
              <Input type="number" min="0" step="0.01" value={cPrices[item.id]||""}
                onChange={e=>setCPrices(p=>({...p,[item.id]:e.target.value}))}
                style={{width:100,textAlign:"right"}} placeholder="0,00"/>
            </div>
          </div>
        ))}
        <Field label="Observação">
          <Input value={cObs} onChange={e=>setCObs(e.target.value)} placeholder="Prazo de entrega, condições..."/>
        </Field>
        <div>
          <div style={{fontSize:12,fontWeight:700,color:T.muted,marginBottom:6}}>📄 Orçamento em PDF ({cFiles.length})</div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
            {cFiles.map((file,i)=>(
              <div key={file.id||i} style={{position:"relative",display:"flex",alignItems:"center",gap:6,padding:"8px 10px",borderRadius:10,border:`1px solid ${T.border}`,background:T.card2,maxWidth:220}}>
                <span style={{fontSize:18}}>📄</span>
                <button type="button" onClick={()=>window.open(file.url||file.dataUrl,"_blank")} style={{background:"none",border:"none",padding:0,color:T.accent,cursor:"pointer",fontSize:11,textAlign:"left",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:150}}>{file.name||`Orçamento ${i+1}.pdf`}</button>
                <button onClick={()=>setCFiles(p=>p.filter((_,j)=>j!==i))}
                  style={{position:"absolute",top:-6,right:-6,width:18,height:18,borderRadius:"50%",background:T.red,border:"none",color:"#fff",fontSize:11,cursor:"pointer"}}>×</button>
              </div>
            ))}
            <button onClick={addCotacaoPdf}
              style={{minWidth:72,height:64,padding:"0 12px",borderRadius:10,border:`2px dashed ${T.border}`,background:T.card2,cursor:"pointer",color:T.muted,fontSize:12,fontWeight:700}}>+ PDF</button>
          </div>
          <div style={{fontSize:11,color:T.muted,marginTop:6}}>Somente arquivos PDF são aceitos para orçamento.</div>
        </div>
        <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
          <Btn variant="ghost" onClick={onClose}>Cancelar</Btn>
          <Btn onClick={()=>{
            if(!cSupplier){show("Selecione o fornecedor.","error");return;}
            onSave({supplierName:cSupplier,items:(order.items||[]).map(i=>({itemId:i.id,price:Number(cPrices[i.id]||0)})),obs:cObs,files:cFiles,photos:cFiles.map(f=>f.url)});
            onClose();
          }}>💰 Registrar Cotação</Btn>
        </div>
      </div>
    </Modal>
  );
}


function ReceiveModal({order, onSave, onClose, setLightbox}) {
  const [nfNum,      setNfNum]      = useState("");
  const [nfPhotos,   setNfPhotos]   = useState([]);
  const [recQtys,    setRecQtys]    = useState(Object.fromEntries((order.items||[]).map(i=>[i.id,String(Math.max(0,(i.quantity||0)-(i.qtyReceived||0)))])));
  const [conditions, setConditions] = useState(Object.fromEntries((order.items||[]).map(i=>[i.id,"Bom"])));
  const [receiveDate,setReceiveDate]= useState(today());
  const [dueDate,    setDueDate]    = useState(today());
  const [paymentMethod,setPaymentMethod] = useState("");
  const [targetCostCenter,setTargetCostCenter] = useState(order?.costCenter || "");
  const [valueOverride,setValueOverride] = useState("");
  const [justificationMissing,setJustificationMissing] = useState("");

  function addNfPhoto(){
    const inp=document.createElement("input");inp.type="file";inp.accept="image/*,application/xml";inp.multiple=true;
    inp.onchange=async e=>{for(const f of Array.from(e.target.files)){const b64=await new Promise(r=>{const fr=new FileReader();fr.onload=()=>r(fr.result);fr.readAsDataURL(f);});setNfPhotos(p=>[...p,b64]);}};
    inp.click();
  }

  const estimatedTotal = (order.items||[]).reduce((sum, item)=>{
    const qty = Number(recQtys[item.id]||0);
    const unitPrice = Number(item?.approvedPrice || item?.price || 0);
    return sum + (qty * unitPrice);
  }, 0);

  return(
    <Modal open={true} onClose={onClose} title="📦 Receber Pedido" wide>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <div style={{background:`${T.green}15`,border:`1px solid ${T.green}44`,borderRadius:10,padding:"10px 16px",fontSize:12,color:T.green}}>
          ✅ Ao confirmar, os itens entram automaticamente no estoque vinculado e já podem gerar o lançamento contábil do recebimento.
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          <Field label="Número da Nota Fiscal">
            <Input value={nfNum} onChange={e=>setNfNum(e.target.value)} placeholder="Ex: 001234"/>
          </Field>
          <Field label="Foto / NF-e XML">
            <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
              {nfPhotos.map((ph,i)=>(
                <div key={i} style={{position:"relative"}}>
                  <img src={ph} alt="" onClick={()=>setLightbox({photos:nfPhotos,idx:i})}
                    style={{width:44,height:44,objectFit:"cover",borderRadius:6,cursor:"pointer",border:`1px solid ${T.border}`}}/>
                  <button onClick={()=>setNfPhotos(p=>p.filter((_,j)=>j!==i))}
                    style={{position:"absolute",top:-5,right:-5,width:16,height:16,borderRadius:"50%",background:T.red,border:"none",color:"#fff",fontSize:10,cursor:"pointer"}}>×</button>
                </div>
              ))}
              <button onClick={addNfPhoto}
                style={{width:44,height:44,borderRadius:6,border:`2px dashed ${T.border}`,background:T.card2,cursor:"pointer",color:T.muted,fontSize:18}}>+</button>
            </div>
          </Field>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(2,minmax(0,1fr))",gap:12}}>
          <Field label="Data do recebimento">
            <Input type="date" value={receiveDate} onChange={e=>setReceiveDate(e.target.value)}/>
          </Field>
          <Field label="Vencimento / pagamento">
            <Input type="date" value={dueDate} onChange={e=>setDueDate(e.target.value)}/>
          </Field>
          <Field label="Forma de pagamento">
            <Select value={paymentMethod} onChange={e=>setPaymentMethod(e.target.value)}>
              <option value="">Selecione...</option>
              {["PIX","Boleto","Dinheiro","Cartão","Transferência","Prazo","Outro"].map(opt=><option key={opt}>{opt}</option>)}
            </Select>
          </Field>
          <Field label="Centro de custo destino">
            <Input value={targetCostCenter} onChange={e=>setTargetCostCenter(e.target.value)} placeholder="Ex: Pecuária"/>
          </Field>
          <Field label="Valor final do recebimento (R$)">
            <Input type="number" min="0" step="0.01" value={valueOverride} onChange={e=>setValueOverride(e.target.value)} placeholder={`Estimado: ${fmtMoney(estimatedTotal)}`}/>
          </Field>
          <Field label="Justificativa se faltar valor/NF">
            <Input value={justificationMissing} onChange={e=>setJustificationMissing(e.target.value)} placeholder="Explique ausência de NF, valor, prazo..."/>
          </Field>
        </div>
        <div style={{fontSize:12,color:T.muted,marginTop:-4}}>Valor estimado pelos itens recebidos: <strong style={{color:T.text}}>R$ {fmtMoney(estimatedTotal)}</strong></div>
        <div style={{fontWeight:700,fontSize:13,color:T.text,marginBottom:4}}>Itens recebidos:</div>
        {(order.items||[]).map(item=>{
          const pending=Math.max(0,(item.quantity||0)-(item.qtyReceived||0));
          return(
            <div key={item.id} style={{background:T.card2,border:`1px solid ${T.border}`,borderRadius:10,padding:"12px 14px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                <div>
                  <div style={{fontWeight:600,color:T.text,fontSize:13}}>{item.description}</div>
                  <div style={{fontSize:11,color:T.muted}}>
                    Pedido: {item.quantity} {item.unit} · Já recebido: {item.qtyReceived||0} · Pendente: {pending}
                  </div>
                  {item.supplierName&&<div style={{fontSize:11,color:T.muted}}>Fornecedor: {item.supplierName}</div>}
                </div>
                {pending===0&&<Badge color={T.green}>✅ Completo</Badge>}
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                <Field label="Qtd recebida agora">
                  <Input type="number" min="0" max={pending} step="0.001"
                    value={recQtys[item.id]||"0"}
                    onChange={e=>setRecQtys(p=>({...p,[item.id]:e.target.value}))}/>
                </Field>
                <Field label="Condição">
                  <Select value={conditions[item.id]||"Bom"} onChange={e=>setConditions(p=>({...p,[item.id]:e.target.value}))}>
                    {["Bom","Com Avaria","Divergente","Recusado"].map(c=><option key={c}>{c}</option>)}
                  </Select>
                </Field>
              </div>
            </div>
          );
        })}
        <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
          <Btn variant="ghost" onClick={onClose}>Cancelar</Btn>
          <Btn onClick={()=>onSave({nfNum,nfPhotos,date:receiveDate,dueDate,paymentMethod,targetCostCenter,valueOverride,justificationMissing,items:(order.items||[]).map(i=>({itemId:i.id,qtyReceived:recQtys[i.id]||0,condition:conditions[i.id]||"Bom"}))})}>
            📦 Confirmar Recebimento
          </Btn>
        </div>
      </div>
    </Modal>
  );
}

export { DenyModal, CotacaoModal, ReceiveModal };
